import {
     trigger,
     state,
     style,
     transition,
     animate,
   } from "@angular/animations";

export const fadeOpenClose = trigger("fadeOpenClose", [
     state(
          "closed",
          style({
               width: 0,
               opacity: 0,
               overflow: "hidden",
               paddingLeft: 0,
               paddingRight: 0,
          })
     ),
     state(
          "open",
          style({
               width: "65px",
               opacity: 1,
               overflow: "hidden",
          })
     ),
     transition("closed <=> open", animate("300ms ease-in-out")),
]);